// Package Imports
import React, { useState } from "react";

// Components
import { user_types_mobile, user_types_web } from "../../constants";

const AccountTypeItem = ({
  AccountIcon,
  accountType,
  accountValue,
  accountKey,
  onChange,
  selected,
  setSelected,
}) => {
  const isSelected = selected === accountValue
  return ( 
    <button
      value={accountValue}
      type="button"
      className={
        isSelected
          ? "p-4 flex justify-center bg-tripplo-200 w-full rounded-lg  border border-tripplo-300"
          : "p-4 flex justify-center bg-tripplo-600 w-full rounded-lg  border border-tripplo-300"
      }
      onClick={(e) => {
        setSelected(e.currentTarget.value);
        onChange(e.currentTarget.value);
      }}
    >
      <div
        className="flex flex-row flex-nowrap w-full justify-center self-center py-4"
        value={accountValue}
      >
        <div className="pr-2">
          <AccountIcon />
        </div>
        <span className="flex self-center font-bold text-lg pl-2">
          {accountType}
        </span>
      </div>
    </button>
  );
};

const AccountTypeBlock = ({ isMobile, onChange }) => {
  const [selected, setSelected] = useState(null);
  const user_types = isMobile ? user_types_mobile : user_types_web

  return (
    <div className="flex flex-col flex-wrap gap-y-4 relative">
      {user_types.map((type) => {
        return (
          <AccountTypeItem
            key={type.id}
            AccountIcon={type.icon}
            accountType={type.title}
            accountValue={type.value}
            onChange={onChange}
            setSelected={setSelected}
            selected={selected}
          />
        );
      })}
    </div>
  );
};

export default AccountTypeBlock;
